import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type {
  PendingSessionData,
  SessionState,
} from 'features/session/interfaces';

export const initialSessionState: SessionState = {
  id: 0,
  rnsConnectionId: '',
  pendingSession: null,
  isRnsSessionStarted: false,
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState: initialSessionState,
  reducers: {
    setRnsConnectionId: (state, action: PayloadAction<string>) => {
      state.rnsConnectionId = action.payload;
    },
    setSessionId: (state, action: PayloadAction<number>) => {
      state.id = action.payload;
    },
    resetSessionId: (state) => {
      state.id = initialSessionState.id;
      state.isRnsSessionStarted = initialSessionState.isRnsSessionStarted;
    },
    setSessionPending: (state, action: PayloadAction<PendingSessionData>) => {
      state.pendingSession = action.payload;
    },
    clearSessionPending: (state) => {
      state.pendingSession = null;
    },
    rnsSessionStarted: (state) => {
      state.isRnsSessionStarted = true;
    },
    rnsSessionEnded: (state) => {
      state.isRnsSessionStarted = false;
    },
  },
});

export const {
  setRnsConnectionId,
  setSessionId,
  resetSessionId,
  setSessionPending,
  clearSessionPending,
  rnsSessionStarted,
  rnsSessionEnded,
} = sessionSlice.actions;

export const sessionReducer = sessionSlice.reducer;
